module.exports = "a:hover{\r\n    background-color: darkorange;\r\n}"